<template>
    <div class="mortgage-compate-page">

        <div class="row">
            <div class="col-md-6">
                <div class="row">
                    <label for="compareField" class="col-sm-4 col-form-label">Compare</label>
                    <div class="col-sm-8">
                        <select v-model="compareData.compare" class="form-select" id="compareField">
                            <option v-for="compare in compares" :key="compare.key" :value="compare.key">
                                {{ compare.value }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="col-md-3">
                <div class="row">
                    <label for="fromDate" class="col-sm-4 col-form-label">From</label>
                    <div class="col-sm-8">
                        <input type="date" class="form-control" id="fromDate" v-model="compareData.fromDate"
                               :min="fromDate" :max="toDate">
                    </div>
                </div>
            </div>

            <div class="col-md-3">
                <div class="row">
                    <label for="toDate" class="col-sm-4 col-form-label">To</label>
                    <div class="col-sm-8">
                        <input type="date" class="form-control" id="toDate" v-model="compareData.toDate"
                               :min="fromDate" :max="toDate">
                    </div>
                </div>
            </div>

            <div class="col-md-12 mt-3">
                <div class="row">
                    <label for="fromDate" class="col-sm-2 col-form-label">Compare For</label>
                    <div class="col-sm-10">
                        <multiselect multiple v-model="compareData.companies" :options="lenders"
                                     track-by="id" label="name"/>
                    </div>
                </div>
            </div>
        </div>

        <hr>

        <highcharts :constructor-type="'stockChart'" :options="chartOptions"
                    ref="mortgageChart" v-show="isChart"></highcharts>

        <div class="error-messages">
            <div class="alert alert-danger" v-if="errors?.length" role="alert">
                <ul class="list m-0">
                    <li v-for="(value, key) in errors" :key="key">{{ value }}</li>
                </ul>
            </div>
        </div>

        <div class="mt-3">
            <button :disabled="isLoading" class="btn btn-warning w-25" @click="graph">
                {{ !isLoading ? 'Display Graph' : 'Loading...' }}
            </button>
            <button class="btn btn-primary w-25" @click="reset">Clear</button>
        </div>
    </div>
</template>

<script>

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Multiselect from 'vue-multiselect'

import {Chart} from "highcharts-vue";
import Highcharts from "highcharts";
import stockInit from "highcharts/modules/stock";

stockInit(Highcharts);

export default {
    name: "MortgageCompare",
    props: ['lenders', 'fromDate', 'toDate'],
    components: {
        DatePicker,
        Multiselect,
        highcharts: Chart
    },

    data() {
        return {
            errors: null,
            isLoading: false,
            isChart: false,
            format: 'DD MMMM YYYY',

            compareData: {
                fromDate: null,
                toDate: null,

                companies: null,
                compare: 'rate_floating',
            },
            compares: [
                {key: 'rate_floating', value: 'Floating Rates'},
                {key: 'rate_6month', value: '6 Months'},
                {key: 'rate_1year', value: '1 Year'},
                {key: 'rate_2year', value: '2 Year'},
                {key: 'rate_3year', value: '3 Year'},
                {key: 'rate_4year', value: '4 Year'},
                {key: 'rate_5year', value: '5 Year'},
            ],

            colors: ['#058BD7', '#52AA34', '#794BDA', '#F58BD7', '#520A34', '#294BFA'],

            seriesData: {
                name: '',
                type: 'line',
                color: '#000',
                tooltip: {
                    valueDecimals: 2
                },
                turboThreshold: 5000,
                data: [],
            },

            chartOptions: {
                chart: {
                    zoomType: 'x',
                    style: {
                        fontFamily: 'Roboto Condensed, sans-serif',
                        fontSize: "1.2rem"
                    }
                },
                xAxis: {
                    type: 'datetime'
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: ''
                    }
                },
                legend: {
                    enabled: true
                },
                title: {
                    text: ''
                },
                series: [],
                credits: {
                    enabled: false
                },
                plotOptions: {
                    line: {
                        enabled: true,
                        forced: true,
                        dataGrouping: {
                            approximation: 'average',
                            units: [
                                [
                                    'month', [1]]
                            ]
                        }
                    }
                },
            },
        }
    },
    mounted() {
        this.reset();
    },
    methods: {
        reset() {
            this.compareData.fromDate = this.fromDate;
            this.compareData.toDate = this.toDate;
            this.compareData.companies = null;
            this.compareData.compare = 'rate_floating';
            this.resetChart();
        },

        resetChart() {
            this.chartOptions.series = [];
            this.$refs.mortgageChart?.chart?.xAxis[0]?.setExtremes(null,null);
            this.isChart = false;
        },

        graph() {
            this.isLoading = true;
            this.resetChart();

            axios({
                method: 'POST',
                url: '/mortgage/graph',
                data: this.compareData
            }).then(res => {
                for (const key in res.data.rates) {
                    let seriesData = {...this.seriesData};
                    let company = this.compareData.companies.find(o => o.id == key);
                    seriesData.name = company.name;
                    seriesData.color = this.colors[this.chartOptions.series.length];
                    seriesData.data = res.data.rates[key];
                    this.chartOptions.series.push(seriesData);
                }
                this.isChart = true;
            }).catch(error => {
                let data = error.response?.data;
                console.log('error', data)
                this.errors = data?.errors ? Object.values(data.errors).flat() : [data?.message];
            }).finally(() => {
                this.isLoading = false;
            })

            setTimeout(() => {
                this.errors = null
            }, 2500)
        },

        disabledFromDate(date) {
            return (
                this.fromDate &&
                new Date(date).setHours(0, 0, 0, 0) <
                new Date(this.fromDate).setHours(0, 0, 0, 0)
            );
        },
        disabledToDate(date) {
            console.log(this.toDate);
            return (
                this.toDate &&
                new Date(date).setHours(0, 0, 0, 0) >
                new Date(this.toDate).setHours(0, 0, 0, 0)
            );
        },
    },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
